module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_5_before.jpg
// module id = 1166
// module chunks = 0